/**
 * @generated SignedSource<<5a7bb025e63c7ef2d0856feaa6004b0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamFeatureBar_team$data = {
  readonly features: ReadonlyArray<{
    readonly __typename: "CalendarTeamFeature";
  } | {
    readonly __typename: "EmployeeScheduleTeamFeature";
  } | {
    readonly __typename: "FileTeamFeature";
  } | {
    readonly __typename: "KPITeamFeature";
    readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBarKPIItem_KPITeamFeature">;
  } | {
    readonly __typename: "ProductDateTrackerTeamFeature";
    readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature">;
  } | {
    readonly __typename: "ProductTeamFeature";
  } | {
    readonly __typename: "SignalTeamFeature";
    readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBarSignalItem_team">;
  } | {
    readonly __typename: "TodoCategoryTeamFeature";
    readonly id: string;
    readonly todoCategoryTeam: {
      readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBarTodoCategoryItem_todoCategoryTeam">;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly id: string;
  readonly " $fragmentType": "TeamFeatureBar_team";
};
export type TeamFeatureBar_team$key = {
  readonly " $data"?: TeamFeatureBar_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBar_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamFeatureBar_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "features",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TodoCategoryTeam",
              "kind": "LinkedField",
              "name": "todoCategoryTeam",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamFeatureBarTodoCategoryItem_todoCategoryTeam"
                }
              ],
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "type": "TodoCategoryTeamFeature",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "FileTeamFeature",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamFeatureBarSignalItem_team"
                }
              ]
            }
          ],
          "type": "SignalTeamFeature",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CalendarTeamFeature",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamFeatureBarKPIItem_KPITeamFeature"
            },
            (v1/*: any*/)
          ],
          "type": "KPITeamFeature",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "ProductTeamFeature",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature"
                }
              ]
            },
            (v1/*: any*/)
          ],
          "type": "ProductDateTrackerTeamFeature",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "EmployeeScheduleTeamFeature",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "05152407ec0f782bab38f3258f079385";

export default node;
